import seeqLogoOrangeSm2026 from 'resources/img/seeq_logo_orange_2026@0.5x.png';

type SeeqLogo2026Props = {
  className?: string;
};
export const SeeqLogo2026 = ({ className }: SeeqLogo2026Props) => {
  return <img src={seeqLogoOrangeSm2026} width={126} height={51} className={className} />;
};
